/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    code: "I",
    asset: "I. DOANH THU HOẠT ĐỘNG",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "", lknow: "", lkbefore: "" },
  },
  {
    id: 1,
    stt: "01",
    code: "I",
    asset: "1.1. Lãi từ các tài sản tài chính ghi nhận thông qua lãi/lỗ (FVTPL)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 2,
    stt: "01.1",
    code: "I",
    asset: "a. Lãi bán các tài sản tài chính FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 3,
    stt: "01.2",
    code: "I",
    asset: "b. Chênh lệch tăng về đánh giá lại các TSTC FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 4,
    stt: "01.3",
    code: "I",
    asset: "c. Cổ tức, tiền lãi phát sinh từ tài sản tài chính FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 5,
    stt: "02",
    code: "I",
    asset: "1.2. Lãi từ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 6,
    stt: "03",
    code: "I",
    asset: "1.3. Lãi từ các khoản cho vay và phải thu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 7,
    stt: "04",
    code: "I",
    asset: "1.4. Lãi từ tài sản chính sẵn sàng để bán (AFS)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 8,
    stt: "05",
    code: "I",
    asset: "1.5. Lãi từ các công cụ phái sinh phòng ngừa rủi ro",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },

  {
    id: 10,
    stt: "06",
    code: "I",
    asset: "1.6. Doanh thu nghiệp vụ môi giới chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 11,
    stt: "07",
    code: "I",
    asset: "1.7. Doanh thu nghiệp vụ bảo lãnh, đại lý phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 12,
    stt: "08",
    code: "I",
    asset: "1.8. Doanh thu nghiệp vụ tư vấn đầu tư chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 13,
    stt: "09",
    code: "I",
    asset: "1.9. Doanh thu nghiệp vụ lưu ký chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 14,
    stt: "10",
    code: "I",
    asset: "1.10. Doanh thu hoạt động tư vấn tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 15,
    stt: "11",
    code: "I",
    asset: "1.11. Thu nhập hoạt động khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 17,
    stt: "20",
    code: "I",
    asset: "Cộng doanh thu hoạt động (20=01->11)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 18,
    stt: "",
    code: "I",
    asset: "II. CHI PHÍ HOẠT ĐỘNG",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "", lknow: "", lkbefore: "" },
  },
  {
    id: 19,
    stt: "21",
    code: "I",
    asset: "2.1. Lỗ các tài sản tài chính ghi nhận thông qua lãi/lỗ (FVTPL)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 20,
    stt: "21.1",
    code: "I",
    asset: "a. Lỗ bán các tài sản tài chính FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 21,
    stt: "21.2",
    code: "I",
    asset: "b. Chênh lệch giảm đánh giá lại các TSTC FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 22,
    stt: "21.3",
    code: "I",
    asset: "c. Chi phí giao dịch mua các tài sản tài chính FVTPL",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 23,
    stt: "22",
    code: "I",
    asset: "2.2. Lỗ các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 24,
    stt: "23",
    code: "I",
    asset:
      "2.3. Lỗ và ghi nhận chênh lệch đánh giá theo giá trị hợp lý tài sản tài chính sẵn sàng để bán (AFS) khi phân loại lại",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 25,
    stt: "24",
    code: "I",
    asset:
      "2.4. Chi phí dự phòng tài sản tài chính, xử lý tổn thất các khoản phải thu khó đòi và lỗ suy giảm tài sản tài chính và chi phí đi vay của các tài khoản cho vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 26,
    stt: "25",
    code: "I",
    asset: "2.5. Lỗ từ các tài sản tài chính phái sinh phòng ngừa rủi ro",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 27,
    stt: "26",
    code: "I",
    asset: "2.6. Chi phí hoạt động tự kinh doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 28,
    stt: "27",
    code: "I",
    asset: "2.7. Chi phí nghiệp vụ môi giới chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 29,
    stt: "28",
    code: "I",
    asset: "2.8. Chi phí nghiệp vụ bão lãnh, đại lý phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 30,
    stt: "29",
    code: "I",
    asset: "2.9. Chi phí nghiệp vụ tư vấn đầu tư chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 31,
    stt: "30",
    code: "I",
    asset: "2.10. Chi phí nghiệp vụ lưu ký chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 32,
    stt: "31",
    code: "I",
    asset: "2.11. Chi phí nghiệp vụ tư vấn tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 33,
    stt: "32",
    code: "I",
    asset: "2.12. Chi phí các dịch vụ khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 34,
    stt: "40",
    code: "I",
    asset: "Cộng chi phí hoạt động (40=21->32)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 35,
    stt: "",
    code: "I",
    asset: "III. DOANH THU HOẠT ĐỘNG TÀI CHÍNH",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "", lknow: "", lkbefore: "" },
  },
  {
    id: 36,
    stt: "41",
    code: "I",
    asset: "3.1. Chênh lệch lãi tỷ giá hối đoái đã và chưa thực hiện",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 37,
    stt: "42",
    code: "I",
    asset: "3.2. Doanh thu, dự thu cổ tức, lãi tiền gửi ngân hàng không cố định",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 38,
    stt: "43",
    code: "I",
    asset: "3.3. Lãi bán, thanh lý các khoản đầu tư vào công ty con, liên kết, liên doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 39,
    stt: "44",
    code: "I",
    asset: "3.4. Doanh thu khác về đầu tư",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 40,
    stt: "50",
    code: "I",
    asset: "Cộng doanh thu hoạt động tài chính (50=41->44)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 41,
    stt: "",
    code: "I",
    asset: "IV. CHI PHÍ TÀI CHÍNH",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "", lknow: "", lkbefore: "" },
  },
  {
    id: 42,
    stt: "51",
    code: "I",
    asset: "4.1. Chênh lệch lỗ tỷ giá hối đoái đã và chưa thực hiện",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 43,
    stt: "52",
    code: "I",
    asset: "4.2. Chi phí lãi vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 44,
    stt: "53",
    code: "I",
    asset: "4.3. Lỗ bán, thanh lý các khoản đầu tư vào công ty con, liên kết, liên doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 45,
    stt: "54",
    code: "I",
    asset: "4.4. Chi phí dự phòng suy giảm giá trị các khoản đầu tư tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 46,
    stt: "55",
    code: "I",
    asset: "4.5. Chi phí tài chính khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  // {
  //   id: 70,
  //   stt: "56",
  //   code: "I",
  //   asset: "5. Phần lãi, lỗ trong công ty liên doanh, liên kết",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  {
    id: 47,
    stt: "60",
    code: "I",
    asset: "Cộng chi phí tài chính (60=51->55)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 48,
    stt: "61",
    code: "I",
    asset: "V. CHI PHÍ BÁN HÀNG",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 49,
    stt: "62",
    code: "I",
    asset: "VI. CHI PHÍ QUẢN LÝ CÔNG TY CHỨNG KHOÁN",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 50,
    stt: "70",
    code: "I",
    asset: "VII. KẾT QUẢ HOẠT ĐỘNG (70=20+50-40-60-61-62)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 51,
    stt: "",
    code: "I",
    asset: "VIII. THU NHẬP KHÁC VÀ CHI PHÍ KHÁC",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "", lknow: "", lkbefore: "" },
  },
  {
    id: 52,
    stt: "71",
    code: "I",
    asset: "8.1. Thu nhập khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 53,
    stt: "72",
    code: "I",
    asset: "8.2. Chi phí khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 54,
    stt: "80",
    code: "I",
    asset: "Cộng kết quả hoạt động khác (80=71-72)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 55,
    stt: "90",
    code: "I",
    asset: "IX. TỔNG LỢI NHUẬN KẾ TOÁN TRƯỚC THUẾ (90=70+80)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 56,
    stt: "91",
    code: "I",
    asset: "9.1. Lợi nhuận đã thực hiện",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 57,
    stt: "92",
    code: "I",
    asset: "9.2. Lợi nhuận chưa thực hiện",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 58,
    stt: "100",
    code: "I",
    asset: "X. CHI PHÍ THUẾ TNDN",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 59,
    stt: "100.1",
    code: "I",
    asset: "10.1. Chi phí thuế TNDN hiện hành",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 60,
    stt: "100.2",
    code: "I",
    asset: "10.2. Chi phí thuế TNDN hoãn lại",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 61,
    stt: "200",
    code: "I",
    asset: "XI. LỢI NHUẬN KẾ TOÁN SAU THUẾ TNDN (200=90-100)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  // {
  //   id: 71,
  //   stt: "201",
  //   code: "I",
  //   asset: "11.1. Lợi nhuận sau thuế phân bố cho chủ sở hữu",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  // {
  //   id: 72,
  //   stt: "202",
  //   code: "I",
  //   asset: "11.2. Lợi nhuận sau thuế trích các quỹ",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  // {
  //   id: 73,
  //   stt: "203",
  //   code: "I",
  //   asset: "11.3. Lợi nhuận thuần phân bố cho lợi ích của cổ đông không kiểm soát",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  {
    id: 62,
    stt: "300",
    code: "I",
    asset: "XII. THU NHẬP (LỖ) TOÀN DIỆN KHÁC SAU THUẾ TNDN",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 63,
    stt: "301",
    code: "I",
    asset: "12.1. Lãi/(lỗ) từ đánh giá lại các tài sản tài chính sẵn sàng để bán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 64,
    stt: "302",
    code: "I",
    asset: "12.2. Lãi/(lỗ) chênh lệch tỷ giá của hoạt động tại nước ngoài",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 65,
    stt: "303",
    code: "I",
    asset: "12.3. Lãi, lỗ đánh giá lại tài sản cố định theo mô hình giá trị hợp lý",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 66,
    stt: "304",
    code: "I",
    asset: "12.4. Lãi, lỗ toàn diện khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  // {
  //   id: 74,
  //   stt: "305",
  //   code: "I",
  //   asset:
  //     "12.5. Lãi, lỗ từ các khoản đầu tư vào công ty con, công ty liên kết, liên doanh chưa chia",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  // {
  //   id: 75,
  //   stt: "306",
  //   code: "I",
  //   asset: "12.6. Lãi, lỗ đánh giá công cụ phái sinh",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  // {
  //   id: 76,
  //   stt: "307",
  //   code: "I",
  //   asset: "12.7. Lãi, lỗ đánh giá lại tài sản cố định theo mô hình giá trị hợp lý",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  {
    id: 67,
    stt: "400",
    code: "I",
    asset: "Tổng thu nhập toàn diện",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  // {
  //   id: 77,
  //   stt: "401",
  //   code: "I",
  //   asset: "Thu nhập toàn diện phân bố cho chủ sở hữu",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  // {
  //   id: 78,
  //   stt: "402",
  //   code: "I",
  //   asset: "Thu nhập toàn diện phân bố cho cổ đông không nắm quyền kiểm soát",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  // },
  {
    id: 67,
    stt: "500",
    code: "",
    asset: "XIII. THU NHẬP THUẦN TRÊN CỔ PHIẾU PHỔ THÔNG",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: "", before: "", lknow: "", lkbefore: "" },
  },
  {
    id: 68,
    stt: "501",
    code: "I",
    asset: "13.1. Lãi cơ bản trên cổ phiếu (Đồng/1 cổ phiếu)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
  {
    id: 69,
    stt: "502",
    code: "I",
    asset: "13.2. Thu nhập pha loãng trên cổ phiếu (Đồng/1 cổ phiếu)",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0, lknow: 0, lkbefore: 0 },
  },
];

export default function Table2({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Chi tiêu
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Mã số
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Thuyết minh
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Quý 3
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Lũy kế từ đầu năm đến cuối quý này
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
              <Th style={{ textAlign: "center" }}>3</Th>
              <Th style={{ textAlign: "center" }}>4</Th>
              <Th style={{ textAlign: "center" }}>5</Th>
              <Th style={{ textAlign: "center" }}>6</Th>
              <Th style={{ textAlign: "center" }}>7</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {rows.valueCenter && rows.valueCenter === true ? (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.now}
                      </Td>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.before}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="now"
                          readOnly={rows.readOnly}
                          value={rows.value.now}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="before"
                          readOnly={rows.readOnly}
                          value={rows.value.before}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      {/*  */}
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="lknow"
                          readOnly={rows.readOnly}
                          value={rows.value.lknow}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="lkbefore"
                          readOnly={rows.readOnly}
                          value={rows.value.lkbefore}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
      {/* <Footer formData={formData} /> */}
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
